import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { ComponentBase, RentalObjectInfo, ObjectTypeInfo } from 't4core';
import { LayoutService } from 'app-components';


@Component({
    selector: 'view-content',
    templateUrl: './view-content.html',
    styleUrls: ['./view-content.css'],
    standalone: false
})
export class ViewContentComponent extends ComponentBase implements OnInit {
  @Input() public centered: boolean = false;
  @Input() public fullscreen: boolean = false;
  @Input() public nopadding: boolean = false;
  @Input() public noScrollY: boolean = false;

  constructor(public Layout: LayoutService) {
    super();
  }

  ngOnInit(): void {
  }
}
